// extracted by mini-css-extract-plugin
export default {"bonus-history-button":"bonus-header-item_bonus-history-button__8QWz6"};